module.exports = __webpack_public_path__ + "img/cnrhVkzwxjPwAaCfPbdc.1b71a9dc.png";